import {
	Component,
	ElementRef,
	inject,
	OnInit,
	ViewChild,
	ViewEncapsulation
} from '@angular/core';
import {
	ActivatedRoute,
	Router
} from '@angular/router';
import {environment} from 'src/environments/environment';
import {config} from '../config/custom.config';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {LPService} from "../shared/services/lp.service";

@Component({
	selector: 'app-credit-card-list',
	templateUrl: './credit-card-list.component.html',
	styleUrls: ['./credit-card-list.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class CreditCardListComponent implements OnInit {
	@ViewChild('popupContent', {static: true}) popupContent: ElementRef | undefined;
	@ViewChild('faqContent', {static: true}) faqContent: ElementRef | undefined;
	loanPurpose: string = 'CC';
	merchantId: any;
	creditCards: any;
	personalCC: any = [];
	allBusinessCC: any = []
	allBusinessCCCharge: any = [];
	businessCC: any = []
	optionModel: any;
	skeletonCards: any = [1, 2, 3];
	activeNavTab: number = 1;
	showRewardsDisclosure: boolean = false;
	private modalService = inject(NgbModal);

	constructor(private activatedRoute: ActivatedRoute,
		private lpService: LPService,
		private router: Router) {
		this.creditCards = [];
	}

	ngOnInit() {
		this.activatedRoute.params.subscribe((params: any) => {
			console.log(params)
			this.merchantId = params['merchantId'];
			if (this.merchantId && this.merchantId.length > 0) {
				//  this.getPartnerDetails();
				this.getOfferDetails();

			}
		});
		if (!this.merchantId) {
			this.activatedRoute.queryParams.subscribe(params => {
				console.log(params, "params - in card list");
				this.merchantId = params['merchantId'];
				if (this.merchantId && this.merchantId.length > 0) {
					//  this.getPartnerDetails();
					this.getOfferDetails();

				}
			});
		}

		if (!this.merchantId) {
			this.router.navigate(['/error']);
		}
	}

	gotoCXUrl() {
		if (this.merchantId) {
			let url = `${environment.cxUrl}/product/${this.loanPurpose}?merchantId=${this.merchantId}`;
			window.open(url, "_blank");
		}
	}

	getOfferDetails(): void {
		// Make the HTTP request with the authorization header
		this.lpService.getPartnerProducts(this.merchantId).subscribe({
			next: (response: any) => {
				if (response && Array.isArray(response) && response.length > 0) {
					this.setCreditCards(response);
				} else {
					this.router.navigate(['/error']);
				}
			},
			error: (error) => {
				console.error('Error:', error);
			}

		});
	}


	setCreditCards(subProducts: any) {
		let CCConfigVal = config.CC.offerVariationDetails;
		let BCCConfigVal = config.BCC.offerVariationDetails;
		let BCCChargeConfigVal = config.BCC_CHARGE.offerVariationDetails;

		Object.keys(CCConfigVal).forEach((key) => {
			if (subProducts.includes(key)) {
				let cc = {name: '', subTitle: '', longInfo: '', shortInfo: '', imageUrl: '', id: ''};
				cc.name = CCConfigVal[key] ? CCConfigVal[key]['title'] : '';
				cc.id = key;
				cc.longInfo = CCConfigVal[key] ? CCConfigVal[key]['longInfo'] : '';
				// cc.shortInfo = CCConfigVal[subProducts[i]] ? CCConfigVal[subProducts[i]]['shortInfo'] : '';
				cc.subTitle = CCConfigVal[key] ? CCConfigVal[key]['subTitle'] : '';
				cc.imageUrl = `${environment.s3Images}images/${environment.institutionCode}/${this.merchantId}_${key}.png`;
				this.personalCC.push(cc);
				//	console.log("adding to CC ->", cc);
			}

		})

		Object.keys(BCCConfigVal).forEach((key) => {
			if (subProducts.includes(key)) {
				let cc = {name: '', subTitle: '', longInfo: '', shortInfo: '', imageUrl: '', type: '', id: ''};
				cc.name = BCCConfigVal[key] ? BCCConfigVal[key]['title'] : '';
				cc.id = key;
				cc.longInfo = BCCConfigVal[key] ? BCCConfigVal[key]['longInfo'] : '';
				cc.type = BCCConfigVal[key] ? BCCConfigVal[key]['type'] : '';
				// cc.shortInfo = CCConfigVal[subProducts[i]] ? CCConfigVal[subProducts[i]]['shortInfo'] : '';
				cc.subTitle = BCCConfigVal[key] ? BCCConfigVal[key]['subTitle'] : '';
				cc.imageUrl = `${environment.s3Images}images/${environment.institutionCode}/${this.merchantId}_${key}.png`;
				this.allBusinessCC.push(cc);
				//	console.log("adding to BCC ->", cc);
			}
		})

		Object.keys(BCCChargeConfigVal).forEach((key) => {
			if (subProducts.includes(key)) {
				let cc = {name: '', subTitle: '', longInfo: '', shortInfo: '', imageUrl: '', type: '', id: ''};
				cc.name = BCCChargeConfigVal[key] ? BCCChargeConfigVal[key]['title'] : '';
				cc.id = key;
				cc.longInfo = BCCChargeConfigVal[key] ? BCCChargeConfigVal[key]['longInfo'] : '';
				cc.type = BCCChargeConfigVal[key] ? BCCChargeConfigVal[key]['type'] : '';
				// cc.shortInfo = CCConfigVal[subProducts[i]] ? CCConfigVal[subProducts[i]]['shortInfo'] : '';
				cc.subTitle = BCCChargeConfigVal[key] ? BCCChargeConfigVal[key]['subTitle'] : '';
				cc.imageUrl = `${environment.s3Images}images/${environment.institutionCode}/${this.merchantId}_${key}.png`;
				this.allBusinessCCCharge.push(cc);
				//console.log("adding to BCC_CHARGE ->", cc);
			}
		})

		if (this.personalCC.length > 0) {
			this.setLoanPurpose('CC');
		}

		if (this.personalCC.length === 0 && (this.allBusinessCCCharge.length > 0 || this.allBusinessCC.length > 0)) {
			this.activeNavTab = 2;
			this.selectBusinessCardType();
		}
	}

	setLoanPurpose(loanPurpose: string) {
		this.loanPurpose = loanPurpose;

		this.showRewardsDisclosure = (loanPurpose === 'CC' ? this.personalCC : this.businessCC).filter((cc: any) => {
			return cc.name.toLowerCase().includes('rewards')
		}).length > 0;
	}

	selectBusinessCardType() {
		this.businessCC = [];

		this.optionModel = this.modalService.open(this.popupContent, {
			centered: true,
			modalDialogClass: 'options-model-container',
			backdrop: 'static',
			keyboard: false
		});
		this.setLoanPurpose('BCC');
	}

	updateAccountType(accountType = 'BCC') {
		if (accountType === 'BCC') {
			this.businessCC = this.allBusinessCC.filter((item: any) => item.type === accountType);
		} else {
			this.businessCC = this.allBusinessCCCharge.filter((item: any) => item.type === accountType);
		}
		this.setLoanPurpose(accountType);
		this.optionModel.close()
	}

	openFAQModel() {
		this.optionModel = this.modalService.open(this.faqContent, {
			centered: true,
			modalDialogClass: 'options-model-container'
		});
	}
}

